import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-progress-bar-text',
  templateUrl: './progress-bar-text.component.html',
  styleUrls: ['./progress-bar-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarTextComponent implements OnInit {
  @Input()
  public currentIndex$: Observable<number>;
  @Input()
  public stepOrder: any[];
  public progressBarText: string;

  ngOnInit(): void {
    this.currentIndex$.subscribe((value) => {
      if (value >= this.stepOrder.length) {
        this.progressBarText = 'Undefined Step';
      } else {
        this.progressBarText = this.stepOrder[value].description;
      }
    });
  }
}
